import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  ListItem,
  ListItemText,
  Stack,
} from "@mui/material";
import React from "react";

import { DistributionTeamMembers } from "../../../../utils/types/distributions.type";
import { ErrorLabel } from "../../../capitalCalls/capitalCallDetails/CapitalCallSetup/CapitalCallSetUp.style";
import { ListStyled } from "./DistributionReview.style";
import {
  StyledDistributionContainer,
  StyledParentCard,
} from "./DistributionSetUp.style";
import { useDistributionReviewers } from "./useDistributionReviews.hook";

const REVIEWERS = [
  "ASSOCIATE",
  "FUND_CONTROLLER",
  "MANAGER",
  "DIRECTOR",
  "FUND_USER_READ_ONLY",
];

type Props = {
  value?: { name?: string }[] | null;
  onChange: (value?: { name?: string }[] | null) => void;
  teamMembers: DistributionTeamMembers;
  disabled?: boolean;
  errorMessage: any;
  setErrorMessage: (value: any) => void;
};

const DistributionReviewers = ({
  onChange,
  value,
  teamMembers,
  disabled,
  errorMessage,
  setErrorMessage,
}: Props) => {
  const { isChecked, handleChange, selectReviewer } = useDistributionReviewers({
    onChange,
    value,
    teamMembers,
    errorMessage,
    setErrorMessage,
  });

  return (
    <FormGroup>
      <StyledDistributionContainer>
        {REVIEWERS.map((reviewer) => {
          const isCheckboxChecked: boolean = isChecked(reviewer);

          return (
            <Stack key={reviewer}>
              <StyledParentCard
                variant="outlined"
                key={reviewer}
                isChecked={isCheckboxChecked}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={disabled}
                      checked={isCheckboxChecked}
                      onChange={() => handleChange(reviewer)}
                    />
                  }
                  label={selectReviewer(reviewer)}
                />
              </StyledParentCard>
              {isChecked(reviewer) && (
                <ErrorLabel>{errorMessage[reviewer]}</ErrorLabel>
              )}
              <ListStyled>
                {isChecked(reviewer) &&
                  teamMembers?.[reviewer as keyof DistributionTeamMembers]?.map(
                    (member) => (
                      <ListItem disablePadding key={member}>
                        <ListItemText>{member}</ListItemText>
                      </ListItem>
                    )
                  )}
              </ListStyled>
            </Stack>
          );
        })}
      </StyledDistributionContainer>
    </FormGroup>
  );
};

export default React.memo(DistributionReviewers);
